import { render, staticRenderFns } from "./StepToStep.vue?vue&type=template&id=5add979f&scoped=true&"
import script from "./StepToStep.vue?vue&type=script&lang=js&"
export * from "./StepToStep.vue?vue&type=script&lang=js&"
import style0 from "./StepToStep.vue?vue&type=style&index=0&id=5add979f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add979f",
  null
  
)

export default component.exports